export default "__VITE_ASSET__DIoZJV25__"